/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { data_ninth_model_rule_category } from './data_ninth_model_rule_category';
import type { unit_option_categories } from './unit_option_categories';
export type data_ninth_option = {
  id: number;
  parent_id: number | null;
  has_choices: number | null;
  name: string;
  name_formated: string;
  category: unit_option_categories;
  mount_id: number | null;
  organisation_id: number;
  organisation_mode: data_ninth_option.organisation_mode;
  type_lvl: data_ninth_option.type_lvl | null;
  model_rule_ids: Array<string>;
  model_rule_categories: Array<data_ninth_model_rule_category>;
  magic_path_id: number | null;
  magic_spell_id: number | null;
};
export namespace data_ninth_option {
  export enum organisation_mode {
    UNIT = 'Unit',
    EXCLUDE_ADD_ORGANISATION = 'ExcludeAddOrganisation',
    CHANGE_UNIT_ORGANISATION = 'ChangeUnitOrganisation',
  }
  export enum type_lvl {
    GLOBAL = 'Global',
    DEFENSIVE = 'Defensive',
    OFFENSIVE = 'Offensive',
    ARMY = 'Army',
  }
}
